import React from 'react';
import styles from 'Custom/Card/index.module.scss';

const CARD_TYPES = {
  enrollment: styles.enrollment,
  carousel: styles.carousel,
  default: styles.carousel,
};

const Card = ({
  className = '',
  title = '',
  subtitle = '',
  image = null,
  type = 'default',
  children,
  ...props
}) => {
  const typeClassName = CARD_TYPES[type] || CARD_TYPES.default;

  return (
    <div data-qa-tag="card-section" className={`${styles.card} ${typeClassName} ${className}`} {...props}>
      {image && <div data-qa-tag="card-image" className={styles.image}>{image}</div>}
      {subtitle && <p data-qa-tag="card-subtitle" className={styles.subtitle}>{subtitle}</p>}
      {title && <h3 data-qa-tag="card-title" className={styles.title}>{title}</h3>}
      <div data-qa-tag="card-content" className={styles.cardContent}>{children}</div>
    </div>
  );
};

export default Card;
